import "./style.css";
import navigation from "./components/navigation/navigation";
import carousel from "./components/carousel/carousel";
import cardCarousel from "./components/card-carousel/card-carousel";
import verticalCarousel from "./components/vertical-carousel/vertical-carousel"
import videoCarousel from "./components/video-carousel/video-carousel"
import locationCarousel from "./components/location-carousel/location-carousel"
import modal from "./components/modal/modal"
import skipTo from "./components/skip-to-content/skip-to-content";

const init = () => {
  navigation();
  carousel();
  cardCarousel();
  verticalCarousel();
  videoCarousel();
  modal();
  skipTo();
  locationCarousel();
};

export const url = () => import.meta.url;

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
}
else {
  init();
}
